(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const syncVideos = (root) => {
    const videos = root.querySelectorAll('video.media__video');
    videos.forEach(v => {
      const hidden = v.closest('[aria-hidden="true"]') || v.closest('.is-hidden');
      try {
        if (hidden) { v.pause(); v.currentTime = 0; }
        else { v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      } catch(_) {}
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('.featured-product-section .product-block, .featured-product-section .media-block')
      .forEach(w => {
        syncVideos(w);
        w.addEventListener('slideshow:initialized', () => syncVideos(w));
        w.addEventListener('slideshow:changed', () => syncVideos(w));
        const obs = new MutationObserver(() => syncVideos(w));
        obs.observe(w, { subtree: true, attributes: true, attributeFilter: ['aria-hidden','class'] });
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
